import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { sendCode, retrievePassword, updatePassword } from '@data/login';
export default {
  name: 'phone-retrieval',
  data: function data() {
    var _this = this;

    /*模块一验证是否发送短信，验证码*/
    var verifyPhoneNum = function verifyPhoneNum(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入您登录系统的手机号码！'));
      } else {
        var reg = /^1\d{10}$/;

        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号码！'));
          _this.isVerifyPhone = true;
        } else {
          _this.isVerifyPhone = false;
        }

        callback();
      }
    };

    var verifyMsgNum = function verifyMsgNum(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入验证码！'));
      } else {
        if (!_this.tools.msgNumVerify(value)) {
          _this.isVerifyMsg = false;
        } else {
          _this.isVerifyMsg = true;
        }

        callback();
      }
    };
    /*模块二验证两次密码输入的是否一致*/


    var verifyEnterPwd = function verifyEnterPwd(rule, value, callback) {
      //            let pattern = /^(\w){6,30}$/;
      if (value === '') {
        callback(new Error('请输入密码！'));
      } else if (!_this.tools.passwordVerify(value)) {
        callback(new Error(_this.msg.WARNING_5));
      } else {
        callback();
      }
    };

    var verifyAgainEnterPwd = function verifyAgainEnterPwd(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码！'));
        _this.isReset = true;
      } else if (value !== _this.resetObj.enterPWD) {
        callback(new Error('两次输入密码不一致！'));
        _this.isReset = true;
      } else {
        callback();
        _this.isReset = false;
      }
    };

    return {
      numCode: 60,
      getCode: '',
      isClick: true,
      //按钮置灰
      timeoutA: null,
      isVerifyPhone: true,
      //未正确填写手机号，禁用“发送验证码”按钮
      isVerifyMsg: true,
      //未填写验证码，禁用“确定”按钮
      hadSend: true,
      //未发送验证码，显示“发送验证码”，发送过就变为“重新发送”
      verifyIdentidy: true,
      //默认在第一个模块--验证身份
      resetPWD: false,
      //第二个模块--修改密码
      getSuccess: false,
      //第三个模块--找回成功

      /*模块一*/
      PWDObj: {
        type: '',
        phoneNum: '',
        name: '',
        account: '',
        msgNum: ''
      },
      phoneRules: {
        phoneNum: [{
          required: true,
          validator: verifyPhoneNum,
          trigger: 'blur'
        }],
        msgNum: [{
          required: true,
          validator: verifyMsgNum,
          trigger: 'change'
        }]
      },

      /*模块二*/
      isReset: true,
      //重置密码模块，两次输入的密码一致，“确定”按钮可点击
      resetObj: {
        enterPWD: '',
        againEnterPWD: ''
      },
      resetRules: {
        enterPWD: [{
          required: true,
          trigger: 'blur',
          validator: verifyEnterPwd,
          min: 6,
          max: 30
        }],
        againEnterPWD: [{
          required: true,
          trigger: 'blur',
          validator: verifyAgainEnterPwd,
          min: 6,
          max: 30
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {},
  watch: {
    'resetObj.enterPWD': function resetObjEnterPWD() {
      if (this.tools.passwordVerify(this.resetObj.enterPWD) && this.resetObj.enterPWD === this.resetObj.againEnterPWD && this.resetObj.enterPWD !== '' && this.resetObj.againEnterPWD !== '') {
        this.isReset = false;
      } else {
        this.isReset = true;
      }
    },
    'resetObj.againEnterPWD': function resetObjAgainEnterPWD() {
      if (this.tools.passwordVerify(this.resetObj.enterPWD) && this.resetObj.enterPWD === this.resetObj.againEnterPWD && this.resetObj.enterPWD !== '' && this.resetObj.againEnterPWD !== '') {
        this.isReset = false;
      } else {
        this.isReset = true;
      }
    }
  },
  methods: {
    //        checkPassword(val) {
    //            let pattern = /^(\w){6,30}$/;
    //            return !!pattern.exec(val);
    //        },

    /**
     *
     * 倒计时
     * */
    time: function time() {
      var self = this;

      if (this.numCode == 0) {
        this.isClick = false;
        this.getCode = '重新发送';
        this.numCode = 60;
      } else {
        if (this.numCode == 60) {
          this.sendVerifyMsg();
        }

        this.isClick = true;
        this.getCode = '重新发送(' + this.numCode + ')';
        this.numCode--;
        this.timeoutA = setTimeout(function () {
          self.time();
        }, 1000);
      }
    },
    //获取短信验证码
    sendVerifyMsg: function sendVerifyMsg() {
      var _this2 = this;

      var self = this;
      var params = {
        mobile: this.PWDObj.phoneNum,
        type: this.PWDObj.type
      };
      sendCode(params).then(function (res) {
        self.hadSend = false;
        self.PWDObj.account = res.account;
        _this2.PWDObj.name = res.name;

        if (res.type == 5) {
          self.PWDObj.type = '学生';
        } else if (res.type == 98) {
          self.PWDObj.type = '家长';
        } else if (res.type == 7) {
          self.PWDObj.type = '教师';
        }
      }).catch(function () {});
    },
    //模块一：身份验证信息发送
    confirmSendInfoFn: function confirmSendInfoFn() {
      var self = this;
      var params = {
        mobile: this.PWDObj.phoneNum,
        code: this.PWDObj.msgNum
      };
      retrievePassword(params).then(function () {
        self.verifyIdentidy = false;
        self.resetPWD = true;
      }).catch(function () {
        self.PWDObj.msgNum = '';
        self.isVerifyMsg = true;
      });
    },
    //模块二：发送重置密码
    resetPWDFn: function resetPWDFn() {
      var self = this;
      var params = {
        password: this.resetObj.enterPWD
      };
      updatePassword(params).then(function () {
        self.verifyIdentidy = false;
        self.resetPWD = false;
        self.getSuccess = true;
      }).catch(function () {});
    },
    toLogin: function toLogin() {
      this.$router.push('/login');
    }
  }
};